/* eslint 'no-useless-constructor': 'off' */
import React, { Component } from 'react';
import { Col, Button, FormGroup } from 'reactstrap';
import {connect} from "react-redux";
import '../../../../Assets/EnsembleStyles/ChangeLimits.css';

 class DeleteConfirmation extends Component {
    constructor(props){
        super(props);
    }
    render(getLabels) {
        var	Delete	=	this.props.Delete;
        let label = this.props.getLabels;
        return (
            <div className="delete_confirmation_Modal">
                <h4 id="label_deletereport" className="Modal_form_title" >  {this.props.parentToChildData[0]}</h4>
                <div id="label_deleteuatext" className="delete_msg_content">
                {this.props.parentToChildData[1]}
                </div>
                    <FormGroup row >
                        <Col sm={{ size: 12 }}>
                            <Button id="button_nodelete" className="btn-gray btn-md" onClick={() => Delete('Cancel')}>{label['WorkOrders.No.Text'] !== undefined ?label['WorkOrders.No.Text'] : "No" }</Button>
                            <Button id="button_yesdelete" className="btn-success btn-md" onClick={() => Delete('yes')}> {label['WorkOrders.Yes.Text']!== undefined ? label['WorkOrders.Yes.Text'] : "Yes, Delete"}</Button>                     
                        </Col>
                    </FormGroup>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        getLabels : state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    };
};
export default connect(mapStateToProps,null)(DeleteConfirmation);

